<template>
  <div class="credit-page">
    <el-card shadow="never">
      <!-- 推广分销 -->
      <span class="member-user-title">推广分销</span>

      <div>
        <a-row :gutter="16">
          <a-col class="gutter-row" :span="12">
            <div class="balance-container" style="background-color: #e6eef9">
              <div class="balance-title">共邀请好友</div>
              <span class="balance-amount" style="color: #3580e6">
                {{ invitedTotal }}
              </span>
            </div>
          </a-col>

          <a-col class="gutter-row" :span="12">
            <div class="balance-container" style="background-color: #fdf1ef">
              <div class="balance-title">累计收益(元)</div>
              <span class="balance-amount" style="color: #eb5858">
                {{ profitTotal }}
              </span>
            </div>
          </a-col>
        </a-row>
      </div>

      <div class="member-promotion">
        <div class="top ceo-background-default ceo-margin-bottom">
          <div class="link">
            <div class="module">
              <div class="title">推广链接</div>
              <div class="input">
                <el-input v-model="inviteUrl"></el-input>
              </div>
              <!-- <button class="button1" onclick="copyText()">复制链接</button> -->
              <button class="button2" @click="imageSharing">分享海报</button>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="invited-box" style="margin: 50px">
        <div class="money-box">
          <div class="money-item">
            <span>共邀请好友</span>
            <p>{{ invitedTotal }}</p>
          </div>

          <div class="money-item">
            <span>累计收益(元)</span>
            <p>{{ profitTotal }}</p>
          </div>
        </div>
      </div> -->

      <!-- <el-form
        label-position="left"
        label-width="80px"
        style="margin-top: 20px"
      >
        <el-form-item label="邀请码">
          <el-input v-model="inviteCode"></el-input>
        </el-form-item>

        <el-form-item label="邀请链接">
          <el-input v-model="inviteUrl"></el-input>
        </el-form-item>

        <el-form-item label="邀请海报">
          <el-button
            type="warning"
            size="small"
            @click="imageSharing"
            v-preventClick
          >
            立即生成
          </el-button>
        </el-form-item>
      </el-form> -->

      <a-tabs v-model="activeName" @tab-click="handleClick">
        <a-tab-pane tab="一级推广" key="first" :item="1">
          <el-table
            border
            :data="invitedList"
            highlight-current-row
            style="width: 100%"
          >
            <el-table-column prop="userId" label="用户编号" align="center" />

            <el-table-column prop="username" label="用户账号" align="center" />

            <el-table-column
              prop="datelineCreateReadable"
              label="注册时间"
              align="center"
            />
          </el-table>

          <div style="float: right; margin: 20px 0px">
            <pagination
              :total="total"
              :current-page="queryParam.pageNum"
              :page-size="queryParam.pageSize"
              @currentChange="handleCurrentChange"
              @editPagesizes="editPageSizes"
            />
          </div>
        </a-tab-pane>

        <a-tab-pane tab="二级推广" key="second" :item="2">
          <el-table
            border
            :data="invitedList"
            highlight-current-row
            style="width: 100%"
          >
            <el-table-column prop="userId" label="用户编号" align="center" />

            <el-table-column prop="username" label="用户账号" align="center" />

            <el-table-column
              prop="datelineCreateReadable"
              label="注册时间"
              align="center"
            />
          </el-table>

          <div style="float: right; margin: 20px 0px">
            <pagination
              :total="total"
              :current-page="queryParam.pageNum"
              :page-size="queryParam.pageSize"
              @currentChange="handleCurrentChange"
              @editPagesizes="editPageSizes"
            />
          </div>
        </a-tab-pane>

        <a-tab-pane tab="三级推广" key="third" :item="3">
          <el-table
            border
            :data="invitedList"
            highlight-current-row
            style="width: 100%"
          >
            <el-table-column prop="userId" label="用户编号" align="center" />

            <el-table-column prop="username" label="用户账号" align="center" />

            <el-table-column
              prop="datelineCreateReadable"
              label="注册时间"
              align="center"
            />
          </el-table>

          <div style="float: right; margin: 20px 0px">
            <pagination
              :total="total"
              :current-page="queryParam.pageNum"
              :page-size="queryParam.pageSize"
              @currentChange="handleCurrentChange"
              @editPagesizes="editPageSizes"
            />
          </div>
        </a-tab-pane>
      </a-tabs>
    </el-card>

    <!-- 分享海报组件 -->
    <FenXiangHaiBao ref="HaiBaoComponent"></FenXiangHaiBao>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import { mapState } from "vuex";

import { invited_list, invitedStatis } from "@/api/user";

import FenXiangHaiBao from "@/pages/mobile/HaiBao.vue";

export default {
  data() {
    return {
      activeName: "first",
      number: [1, 1, 1],
      invitedList: [],
      moneyData: [50, 100, 200, 500],
      payType: [
        {
          img: require("@/assets/image/weixin.png"),
          title: "微信",
          value: "wxpay",
        },
        {
          img: require("@/assets/image/alipay.png"),
          title: "支付宝",
          value: "alipay",
        },
        {
          img: require("@/assets/image/paypal.png"),
          title: "Paypal",
          value: "paypal",
        },
      ],
      from: {
        amount: 0,
        verifyCode: null,
        verifyCodeType: 1,
        platform: "wxpay",
        platformAccount: "",
        platformPerson: "",
      },
      CodeType: [
        { name: "邮箱", id: 1 },
        { name: "手机", id: 2 },
      ],
      valuePay: "微信",
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        inviterLevel: 1,
      },
      invitedTotal: undefined,
      profitTotal: undefined,
    };
  },
  components: {
    Pagination,
    FenXiangHaiBao,
  },
  computed: {
    ...mapState({
      balanceTotal: (state) => state.balance.balanceTotal,
      invited_list: (state) => state.user.invited_list,
      inviteCode: (state) => state.user.inviteCode,
      inviteUrl: (state) => state.user.inviteUrl,
      inviteUrlQrImageUrl: (state) => state.user.inviteUrlQrImageUrl,
    }),
  },
  created() {
    //加载用户信息
    this.$store.dispatch("user/info");

    this.loadData();

    //查询收益统计
    this.queryInvitedStatis();
  },
  methods: {
    /**
     * 查询收益统计
     */
    queryInvitedStatis() {
      var data = {};
      new Promise((resolve, rejust) => {
        invitedStatis(data)
          .then((res) => {
            this.invitedTotal = res.result.invitedTotal;
            this.profitTotal = res.result.profitTotal;

            resolve();
          })
          .catch((error) => {
            rejust(error);
          });
      });
    },

    /**
     * 图片分享
     */
    imageSharing() {
      // Toast({
      //   message: "很快就会推出。敬请期待!",
      // });
      this.$refs.HaiBaoComponent.SubmitOpen();
    },

    handleCash() {
      this.$store.dispatch("withdraw/create", { ...this.from });
    },
    handleCode() {
      this.$store.dispatch("withdraw/code", {
        verifyCodeType: this.from.verifyCodeType,
      });
    },
    changePayType(value, type) {
      console.log(value);
      this.valuePay = value;
      this.from.platform = type;
    },

    handleClick(tab) {
      this.queryParam.inviterLevel = tab.$attrs.item;

      this.queryParam.pageNum = 1;
      this.queryParam.pageSize = 10;

      this.invitedList = [];
      this.loadData();
    },

    /**
     * 加载列表
     */
    loadData() {
      var then = this;
      new Promise((resolve, rejust) => {
        invited_list(this.queryParam)
          .then((res) => {
            then.invitedList = res.result.list;
            then.total = res.result.total;
            resolve();
          })
          .catch((error) => {
            rejust(error);
          });
      });

      // this.number[value.item] = value.number;
      // let data = { offset: (this.number[value.item] - 1) * 10, limit: 10 };
      // data.inviterLevel = value.item + 1;

      // this.queryParam.inviterLevel = value.item + 1;

      // this.$store.dispatch("user/invited_list", this.queryParam).then(() => {
      //   this.lists = this.invited_list;
      //   this.$forceUpdate();
      // });
    },

    // 修改当前页事件
    handleCurrentChange(pageNum) {
      this.queryParam.pageNum = pageNum;
      this.loadData();
    },
    // 修改分页的每页的条数
    editPageSizes(val) {
      this.queryParam.pageSize = val;
      this.loadData();
    },
  },
};
</script>

<style scoped>
.back-img {
  height: 20px;
  margin-right: 10px;
}
.back-btn {
  width: 140px;
  height: 40px;
  color: #5f5f5f;
  border: 2px solid #5f5f5f;
  line-height: 39px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin-right: 20px;
  font-size: 14px;
}
.back-btn.active {
  border: 2px solid #014785;
}
p {
  padding: 0px;
  margin: 0px;
  color: #5f5f5f;
  font-size: 12px;
}
.item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
}
.title {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 23px;
  color: #1b1b1b;
  opacity: 1;
}
.content {
  margin-left: 20px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 22px;
  color: #1b1b1b;
  opacity: 1;
}
.input {
  margin-left: 10px;
  margin-right: 10px;
}
.item.active {
  background: #f8f8f8;
  padding: 10px 20px;
  margin-right: 40px;
  box-sizing: border-box;
  /* padding-right: 40px;  */
  /* width: auto; */
}
.input-title {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 23px;
  color: #1b1b1b;
  opacity: 1;
  margin-left: 20px;
}

.invited-box .money-box {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding: 0 60px;
}

.invited-box .money-box .money-item {
  display: inline-block;
  text-align: center;
}

.invited-box .money-box .money-item span {
  color: #969696;
  font-size: 14px;
}
.invited-box .money-box .money-item p {
  font-weight: 700;
  font-size: 32px;
  color: #e93323;
}

.invited-box .tab-box {
  margin: 30px 0 0;
}

.balance-container {
  padding: 20px;
  border-radius: 4px;
  position: relative;
  margin-bottom: 20px;
}

.balance-container:after {
  content: "";
  position: absolute;
  bottom: 0;
  right: 0;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 71px;
  height: 62px;
}

.balance-title {
  color: #7d8592;
  font-size: 16px;
  margin-bottom: 20px;
  position: relative;
  z-index: 1;
}

.balance-amount {
  display: inline-block;
  font-size: 30px;
  color: #3d4a5d;
  line-height: 1;
  font-family: impact;
}

.balance-description {
  display: block;
  margin-top: 10px;
  color: #fff;
  font-size: 12px;
}

/* 新的 */
/*推广链接*/
.member-promotion .top .link {
  background: #f6f6f6;
  border-radius: 8px;
  position: relative;
  /* margin: 30px 0; */
  padding: 15px;
}
.member-promotion .top .link:after {
  content: "";
  position: absolute;
  bottom: 0;
  right: 10px;
  background-image: url(../../assets/user/member-promotion-link.png);
  background-repeat: no-repeat;
  background-size: 220px 84px;
  width: 220px;
  height: 84px;
}
.member-promotion .top .link .module {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}
.member-promotion .top .link .module .title {
  font-size: 12px;
  color: #999;
  line-height: 43px;
  padding: 0 15px 0 5px;
}
.member-promotion .top .link .module .input {
  margin-right: 15px;
  border: none;
  padding: 0 10px;
  border-radius: 8px;
  font-size: 13px;
  color: #333;
  width: 260px;
  height: 43px;
}
.member-promotion .top .link .module .input input {
  border: none;
  padding: 0 10px;
  border-radius: 8px;
  font-size: 13px;
  color: #333;
  width: 260px;
  height: 43px;
}
.member-promotion .top .link .module .input input:focus {
  outline: none;
}
.member-promotion .top .link .module .button1 {
  display: inline-block;
  vertical-align: middle;
  height: 43px;
  line-height: 43px;
  border: 1px solid transparent;
  padding: 0 20px;
  background-color: #fff;
  color: #3580e6;
  white-space: nowrap;
  text-align: center;
  font-size: 14px;
  border-radius: 8px;
  margin-right: 15px;
  cursor: pointer;
  transition: all 0.3s;
}
.member-promotion .top .link .module .button1:hover {
  opacity: 0.9;
}
.member-promotion .top .link .module .button2 {
  display: inline-block;
  vertical-align: middle;
  height: 43px;
  line-height: 43px;
  border: 1px solid transparent;
  padding: 0 20px;
  background-color: #3580e6;
  color: #fff;
  white-space: nowrap;
  text-align: center;
  font-size: 14px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
}
.member-promotion .top .link .module .button2:hover {
  opacity: 0.9;
}
</style>
